<template>
  <div class="block block--white mt-3">
    <div class="d-flex">
      <div class="col-lg-5 model-data">
        <div class="title model-info">
          {{ name }}
          <span>Lives</span>
        </div>
        <h3 class="description mt-3 model-info">
          {{ description }}
        </h3>
        <p class="ml-5 mt-3 text model-info">
          {{ text }}
        </p>
      </div>
      <div class="col-lg-7 col-sm-12 col-12 col-md-7 box-plyr-live">
        <BoxLive
          v-if="videoSelect"
          ref="playerLive"
          :video="videoSelect"
          :thumbVideo="''"
        />

        <div class="row buttons-video bg-white py-2 px-4">
          <div
            class="col-lg-2 col-11 d-flex justify-content-center align-items-center"
          >
            <select
              class="form-select py-2"
              aria-label="Default-select-parts"
              v-model="videoIndex"
            >
              <option selected disabled>{{ translate.sessions }}</option>
              <option
                :value="index"
                v-for="(live, index) in lives"
                :key="index"
              >
                {{ route.params.language == "pt-br" ? "Parte" : "Part" }}
                {{ index + 1 }}
              </option>
            </select>
          </div>

          <div
            class="col-lg-2 col-1 d-flex justify-content-center align-items-center mobile-download"
            @click="modalConfirmDownload(liveId)"
            v-if="videoSelect"
          >
            <button
              type="button"
              class="btn btn-outline-secondary btn-lg px-2 btn-desktop"
            >
              <span class="video-options">{{ translate.download }}</span>
              <font-awesome
                :icon="['fas', 'download']"
                size="md"
                style="color: #b20000; margin-left: 3px"
              />
            </button>
            <font-awesome
              :icon="['fas', 'download']"
              size="md"
              style="color: #b20000; margin-left: 3px"
            />
          </div>
          <div
            class="col-lg-3 col-1 d-flex justify-content-center align-items-center mobile-bellacloud"
            v-if="podeSalvar"
          >
            <button
              @click="showModalModelBellacloud(true)"
              type="button"
              class="btn btn-outline-secondary btn-lg px-2 btn-desktop"
            >
              <span class="video-options">{{ translate.saveBellaCloud }}</span>
              <font-awesome
                :icon="['far', 'bookmark']"
                size="md"
                style="color: #b20000; margin-left: 3px"
              />
            </button>
            <font-awesome
              @click="showModalModelBellacloud(true)"
              :icon="['far', 'bookmark']"
              size="md"
              style="color: #b20000; margin-left: 3px"
            />
          </div>
        </div>
        <div class="row d-flex px-2">
          <div
            class="cursor-pointer col-xl-3 col-6"
            v-for="(live, index) in lives"
            :key="live.id"
            @click="changePart(index)"
          >
            <div class="d-flex align-items-center justify-content-center title-part">
              <p :class="['text1', { 'text1-active': videoIndex === index }]">
                {{ route.params.language == "pt-br" ? "Parte" : "Part" }}
                {{ index + 1 }}
              </p> <span :class="['dropdown-toggle', { 'dropdown-toggle-right': videoIndex !== index }]"></span>
            </div>
            <div class="box-live">
              <BoxLiveThumb
                :video="live"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalModelBellacloud
    @showModalModelBellacloud="showModalModelBellacloud"
    :showCloud="showCloud"
    tipo="live"
    :imageIdSelected="liveId"
  />
  <ModalMessages
    @showModalMessages="showModalMessages"
    @solicitaDownload="solicitaDownload"
    :options="options"
    :width="isMobile() ? '95%' : '600px'"
  />
</template>

<script lang="ts" setup>
import ModalMessages from "@/components/Modais/ModalMessages.vue";
import ModalModelBellacloud from "@/components/Modais/ModalModelBellacloud.vue";
import BoxLive from "./PlayerLive.vue";
import BoxLiveThumb from "./BoxLiveThumb.vue";
import translateModel from "@/tradutors/model";
import api from "@/api";
import { isMobile } from "~/shared/utils/mobile";
import {
  videoPlayerTools,
  type ControleDoVideo,
} from "@/composables/webmcp/tools.media";

const route = useRoute();

const translate = computed(() =>
  route.params.language == "pt-br"
    ? translateModel.portugues
    : translateModel.ingles
);

const reactiveLocale = computed(() => route.params.language);
const props = defineProps({
  model: {
    type: Object,
    default: null,
  },
  videosModel: {
    type: Object,
    default: null,
  },
});

const name = computed(() => props.model.nameModel);
const description = computed(() => props.model.descriptionModel);
const text = computed(() => props.model.text);

interface VideoPath {
  id: string;
  path: string;
  name: string;
  urlPanda: string;
}

const videoIndex = ref(0);
const videoSelect = computed<VideoPath | false>(
  () => props.videosModel.liveVideos[videoIndex.value]
);

const lives = computed(() => props.videosModel.liveVideos);
const liveId = computed(
  () => props.videosModel.liveVideos[videoIndex.value].id
);
const showCloud = ref(false);
// Quem não é Gold recebe só a prévia, que não se salva.
const podeSalvar = computed(
  () => !!videoSelect.value && videoSelect.value.name !== "preview"
);
function showModalModelBellacloud(value: boolean) {
  showCloud.value = value;
}
const options = ref({
  showModal: false,
  titleModal: "",
  textBodyModal: "",
  textButtonModal: "",
  routerName: "",
  functionOptions: null,
  showClose: true,
});

const plyrOptions = ref({
  controls: [],
});

function showModalMessages(data: any) {
  options.value.showModal = data.message.show;
  options.value.titleModal = data.message.title;
  options.value.textBodyModal = data.message.textBoby;
  options.value.textButtonModal = data.message.textButton;
  options.value.routerName = data.message.routerName;
  options.value.functionOptions = data.message.functionOptions;
  options.value.showClose = data.message.showClose;
}

function modalConfirmDownload(id: number) {
  showModalMessages({
    message: {
      show: true,
      title:
        reactiveLocale.value == "en"
          ? "Click CONFIRM DOWNLOAD to confirm that you want to download the live"
          : "Clique em CONFIRMAR DOWNLOAD para confirmar que você deseja baixar a live",
      textButton:
        reactiveLocale.value == "en"
          ? "CONFIRM DOWNLOAD"
          : "CONFIRMAR DOWNLOAD",
      textBoby:
        reactiveLocale.value == "en"
          ? "This live will use 2 credits from your account"
          : "Esta live utilizará 2 créditos da sua conta",
      functionOptions: { name: "solicitaDownload", parameter: id },
      showClose: true,
    },
  });
}

async function solicitaDownload(id: number) {
  api
    .get(
      "v1/videoscredits/solicitaDownload/live/" +
        id +
        `?locale=${reactiveLocale.value ?? route.params.locale ?? "pt-br"}`
    )
    .then(({ data }) => {
      if (!data.error)
        showModalMessages({
          message: {
            show: true,
            title:
              reactiveLocale.value == "en"
                ? "Your download is being processed!"
                : "Seu download está sendo processado!",
            textButton: reactiveLocale.value == "en" ? "Close" : "Fechar",
            textBoby: data.message,
          },
        });
      else if (
        data.message.includes("Adquira créditos para realizar o download") ||
        data.message.includes("Purchase credits in order to download")
      ) {
        showModalMessages({
          message: {
            show: true,
            title:
              reactiveLocale.value == "en"
                ? "Error your download!"
                : "Falha ao solicitar download!",
            textButton:
              reactiveLocale.value == "en" ? "BUY CREDITS" : "COMPRAR CRÉDITOS",
            textBoby: data.message,
            routerName: "language-assine",
          },
        });
      } else {
        showModalMessages({
          message: {
            show: true,
            title:
              reactiveLocale.value == "en"
                ? "Error your download!"
                : "Falha ao solicitar download!",
            textButton: reactiveLocale.value == "en" ? "Close" : "Fechar",
            textBoby: data.message,
          },
        });
      }
    })
    .catch((err) => {
      showModalMessages({
        message: {
          show: true,
          title:
            reactiveLocale.value == "en"
              ? "Error your download!"
              : "Falha ao solicitar download!",
          textButton: reactiveLocale.value == "en" ? "Close" : "Fechar",
          textBoby: err.response.data.message,
        },
      });
    });
}

function changePart(index: number) {
  videoIndex.value = index;
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

// WebMCP: control_video e choose_video, como na aba Vídeos (Videos.vue), sobre
// o PlayerLive. Cada live é uma parte, com o mesmo rótulo da tela, e não há
// qualidade para escolher.
const playerLive = ref<any>(null);
const controleDoVideo: ControleDoVideo = {
  tipo: "live",
  player: () => playerLive.value?.player?.() ?? null,
  estado: () => ({
    previa: false,
    parte: videoIndex.value,
    partes: lives.value.map((live: any, index: number) => ({
      nome: `${route.params.language == "pt-br" ? "Parte" : "Part"} ${index + 1}`,
      temVideo: Boolean(live?.path),
    })),
    qualidade: null,
    qualidades: [],
  }),
  async escolherParte(indice) {
    const live = lives.value[indice];
    if (!live) return "parte-inexistente";
    if (!live.path) return "parte-sem-video";
    videoIndex.value = indice;
    await nextTick();
    return "ok";
  },
  escolherQualidade: async () => "sem-qualidade",
};
useWebMcpTools((ctx) => videoPlayerTools(ctx, controleDoVideo));
</script>
<style scoped lang="css">
.block {
  padding: 28px 0;
}

#model-video-box {
  width: 827px;
  height: 465px;
}

.fake-player-wait-panda {
  width: 827px;
  height: 465px;
  background-color: #000000;
  position: relative;
}

.title-msg {
  font-family: "Bebas-Neue";
  font-size: 40px;
  font-weight: 400;
  position: absolute;
  z-index: 99;
  color: #ffffff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
  background: rgba(255, 255, 255, 0.2);
  width: 100%;
  height: 80px;
  line-height: 90px;
  cursor: pointer;
}

.model-info {
  padding-left: 137px;
}

h3 h1 p {
  font-family: "Exo-2";
}

.name-video {
  font-family: "Exo-2";
  font-size: 12px;
  font-weight: bold;
  color: #b20000;
}

.form-select {
  background-color: #fff;
  color: #868686;
  font-size: 14px;
  font-weight: 600;
  font-family: "Exo-2";
  border: none;
  background-image: url('');
  --bs-form-select-bg-img: url('');
  pointer-events: none;
}

.form-select:hover {
  background-color: #6c757d;
  color: #fff;
  border-radius: 30px;
  border: none;
}

.title {
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 72px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 72px;
}

.description {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.text {
  height: 76px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  max-width: 370px;
}

.video-options {
  height: 19px;
  font-family: "Exo-2";
  font-size: 15px;
  letter-spacing: 0;
  line-height: 19px;
}

.row .buttons-video > .col,
.row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

.btn-outline-dark {
  font-size: 14px;
  font-weight: 500;
  border-radius: 30px;
}

.btn-outline-secondary {
  font-size: 14px;
  font-weight: 600;
  border-radius: 30px;
  border: none;
}

.mobile-bellacloud > svg,
.mobile-share > svg,
.mobile-download > svg,
.mobile-sections {
  display: none;
}

.model-info span {
  font-family: "Exo-2";
  font-size: 25px;
  line-height: 20px;
  display: block;
  width: 100%;
  font-family: "Bebas-Neue";
}

.box-live {
  width: 100%;
  aspect-ratio: 16 / 9;
  pointer-events: none;
}
:deep(.plyr) {
  min-width: unset !important;
}
:deep(.plyr-list) {
  width: 100% !important;
  height: 113px !important;
  min-width: unset !important;
}

.dropdown-toggle:after {
    font-family: "fontello";
    font-size: 25px;
    content: "\e809";
    margin: 0;
    border: none;
    vertical-align: text-bottom;
    color: #B20000;
    margin-left: 0px;
}

.text1 {
  font-family: "Exo-2";
  color: #b5b5b5;
  font-size: 15px;
  line-height: 21px;
  font-weight: 600;
  margin-bottom: 5px;
  text-align: center;
}

.text1-active {
  font-weight: bold;
  color: #000;
}

.dropdown-toggle-right:after {
  content: "\e80c";
}

.title-part {
  margin-top: 20px;
}

@media screen and (max-width: 992px) {
  .model-data,
  .div-resolution,
  .btn-desktop {
    display: none;
  }

  .block {
    padding: 0px;
    margin-top: 0px !important;
  }

  .mobile-bellacloud > svg,
  .mobile-share > svg,
  .mobile-download > svg,
  .mobile-sections {
    display: block;
  }

  .row :deep(#model-video-box) {
    margin-bottom: 50px;
  }

  .buttons-video {
    box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
    -webkit-box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
    -moz-box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
  }

  .name-video {
    font-family: "Exo-2";
    font-size: 14px;
    font-weight: bold;
    color: #000000;
  }

  .fake-player-wait-panda {
    width: 100%;
    height: 30vh;
    right: unset;
    margin-left: 5px;
  }

  .title-msg {
    font-size: 25px;
    height: 50px;
    line-height: 55px;
    transform: translate(-50%, -130%);
  }

  #model-video-box {
    width: 100%;
    height: unset;
    right: unset;
    margin-left: 10px;
  }
}
</style>
